import {resource} from './resource';

export const useListItems = resource.createUseQueryIndex();
export const useListItem = resource.createUseQueryById();

export const useNextListItem = resource.createUseCustomQuery({
	queryId: 'nextListItem',
	pathName: 'nextListItem',
	defaultUseQueryOptions: {
		// This endpoint is typically used as an action ("give me the next one"),
		// so we don't want react-query to treat results as fresh for 60s.
		staleTime: 0,
	},
});
